import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/pro-xg-aggregation@2x.jpg";
import v3Image from "../../assets/Switching/pro-xg-aggregation.jpg";
import type { Product } from "../../types";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";

export const proXgAggregation: Product = {
  id: "proXgAggregation",
  productTitle: "Pro XG Aggregation",
  description: "proXgAggregation.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-xg-aggregation"],
  storePathParts: {
    productSlug: "usw-pro-xg-aggregation",
    category: "switching-aggregation",
  },
  isNew: true,
  isComingSoon: true,
  comingSoonButtonText: "proXgAggregation.comingSoonButtonText",
  v3Image: {
    src: v3Image,
    width: 239,
    height: 120,
  },
  image: {
    src: image,
    width: 200,
    height: 140,
  },
  productListGroup: productListSwitchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442.4 x 43.7 x 480 mm\n(17.4 x 1.7 x 18.9")',
      },
    },
    {
      propertyId: "portCount",
      value: { type: "string", value: "32" },
    },
    {
      propertyId: "downlinkSpeed",
      value: { type: "string", value: "25 Gbps" },
    },
    {
      propertyId: "uplinkSpeed",
      value: { type: "string", value: "25 Gbps" },
    },
    {
      propertyId: "poeOutput",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "poeAvailability",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "etherlighting",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "proAvSupport",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: "mounting",
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
  ],
};
